import React, { useCallback, useEffect, useRef, useState } from "react";
import "./AttendanceTaker.css";
import { Checkbox, Col, Row, Radio, Menu, Dropdown } from "antd";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  BASE_URL,
  FetchStaff,
  STAFF_ROLE,
  UpdateStaff,
} from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useDispatch, useSelector } from "react-redux";
import StaffDetail from "./staffDetail";
import Filter from "../../assets/icons/filter.svg";
import { useNavigate } from "react-router-dom";
function AttendanceTacker() {
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const designationState = useSelector(
    (state) => state.designation.designation
  );

  const departmentState = useSelector((state) => state.department.department);
  const gridRef = useRef();
  const [formVisible, setFormVisible] = useState(false);
  const [size, setSize] = useState("All");

  const [gridApi, setGridApi] = useState(null);
  const [staffDetail, setStaffDetail] = useState([]);
  const [departments, setDepartments] = useState(departmentState);
  const [designations, setDesignations] = useState(designationState);
  const [selectedFilterStaffTaker, setSelectedFilterStaffTaker] = useState();
  const [staffFilter, setStaffFilter] = useState({
    roles: [STAFF_ROLE.All],
    projection: { needStaffRole: false },
    isInList: true,
  });
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    designation: [],
    department: [],
  });
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };
  const showForm = (item) => {
    setFormVisible(true);
  };
  const hideForm = (item) => {
    setFormVisible(false);
    getStaffList(selectedFilterStaffTaker);
  };
  const toggleSearchVisibility = () => {
    setIsSearchVisible((prevState) => !prevState);
  };

  const handleMenuClick = (e) => {
    let updatedFilter = staffFilter;
    if (e.keyPath[1] == "designation") {
      updatedFilter = {
        designation: e.keyPath[0],
        projection: { needStaffRole: false },
      };
    } else if (e.keyPath[1] == "department") {
      updatedFilter = {
        department: e.keyPath[0],
        projection: { needStaffRole: false },
      };
    }
    getStaffList(updatedFilter);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.SubMenu key="department" title="Department">
        {departments?.map((department) => (
          <Menu.Item key={department.key}>{department.value}</Menu.Item>
        ))}
      </Menu.SubMenu>
      <Menu.SubMenu key="designation" title="Designation">
        {designations.map((designation) => (
          <Menu.Item key={designation.key}>{designation.value}</Menu.Item>
        ))}
      </Menu.SubMenu>
    </Menu>
  );
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  useEffect(() => {
    getStaffList();
  }, [selectedFilters]);

  const getStaffList = async (updatedFilter) => {
    const token = localStorage.getItem("authToken");
    const filtersToSend = Object.fromEntries(
      Object.entries(selectedFilters).filter(([_, value]) => value.length > 0)
    );
    let updatedStaffFilter;
    if (updatedFilter) {
      updatedStaffFilter = { ...updatedFilter, ...filtersToSend };
    } else {
      updatedStaffFilter = { ...staffFilter, ...filtersToSend };
    }

    try {
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(updatedStaffFilter),
        });

        if (response.ok) {
          const data = await response.json();
          const activeStaff = data.data
            .filter((item) => item.isActive)
            .filter((item) => !item.isStaffBo);
          setStaffDetail(activeStaff);
        } else {
          if (response.status === 401) {
            // Logout();
          } else {
            const data = await response.json();
            console.log("stafferr", data);
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      };
      await fetchData();
    } catch (error) {
      console.error("Error updating designation:", error);
    }
  };

  const columnDefs = [
    {
      headerName: "Profile",
      field: "profile",

      flex: 1,
      cellRenderer: (params) => {
        return (
          <>
            <div className="">
              <div className="flex items-center">
                <div>
                  <img
                    className="hisimage min-w-[47px] min-h-[47px] w-[47px] h-[47px] rounded-full"
                    src={params.data?.item?.faceRegisterUrl || params.data?.item?.logo}
                    alt=""
                  />
                </div>
                <div className="pl-[12px]">
                  <p className="text-base !font-sbold">
                    {capitalizeFirstLetter(params.data?.item?.firstName)} {capitalizeFirstLetter(params.data?.item?.lastName)}
                  </p>
                  <p className="text-sm">
                    {capitalizeFirstLetter(
                      params.data?.item?.designation?.designationName
                    )}
                  </p>
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Attendance Taker",
      field: "attendanceTaker",
      flex: 1,
      cellRenderer: (params) => {
        return (
          <Checkbox
            checked={params.data.attendanceTaker}
            onChange={(e) =>
              handleCheckboxChange(
                params?.data?.item,
                "attendanceTaker",
                e.target.checked
              )
            }
          >
            <span className="text-sm !font-bold">Attendance Taker</span>
          </Checkbox>
        );
      },
    },
    {
      headerName: "Add Staff",
      field: "addContractors",

      cellRenderer: (params) => {
        return (
          <>
            <Checkbox
              checked={params.data.addContractors}
              onChange={(e) =>
                handleCheckboxChange(
                  params?.data?.item,
                  "addStaff",
                  e.target.checked
                )
              }
            >
              <span className="text-sm !font-bold">Add Staff</span>
            </Checkbox>
          </>
        );
      },
    },
  ];

  const storedDataString = userInfo?.availableRoles;

  const data = staffDetail?.map((item, index) => {
    const staffRole = item.staffRole || [];
    const attendanceTaker = storedDataString.some(
      (role) =>
        staffRole.includes(role.roleId) &&
        role.uniqueId === STAFF_ROLE.AttendanceTaker
    );
    const addStaff = storedDataString.some(
      (role) =>
        staffRole.includes(role.roleId) && role.uniqueId === STAFF_ROLE.AddStaff
    );

    return {
      key: index,
      item: item,
      profile: item.firstName,
      attendanceTaker: attendanceTaker,
      addContractors: addStaff,
    };
  });

  // Handle checkbox changes
  const handleCheckboxChange = (params, field, checked) => {
    let staffRoleId = "";
    if (field == "attendanceTaker") {
      staffRoleId = storedDataString?.find(
        (item) => item.uniqueId === STAFF_ROLE.AttendanceTaker
      );
    } else if (field == "addStaff") {
      staffRoleId = storedDataString?.find(
        (item) => item.uniqueId === STAFF_ROLE.AddStaff
      );
    }
    let staffRole = params.staffRole;
    if (!staffRole || !Array.isArray(staffRole)) {
      staffRole = []; // If not, create it as an empty array
    }
    const index = staffRole?.indexOf(staffRoleId.roleId);

    if (index !== -1) {
      staffRole.splice(index, 1);
    } else {
      staffRole.push(staffRoleId.roleId);
    }
    updateStaff(staffRole, params?._id);
  };
  const updateStaff = async (staffRole, staffRoleId) => {
    const token = localStorage.getItem("authToken");
    const data = {
      _id: staffRoleId,
      staffRole: staffRole,
    };
    try {
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${UpdateStaff}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          const data = await response.json();
          getStaffList(selectedFilterStaffTaker);
        } else {
          const data = await response.json();
          console.log("stafferr", data);
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      };
      await fetchData();
    } catch (error) {
      console.error("Error updating designation:", error);
    }
  };

  const onChange = (e) => {
    setSize(e.target.value);
  };

  const toggleFilterRadioBtn = (filter) => {
    getStaffList(filter);
    setSelectedFilterStaffTaker(filter);
  };

  const filters = {
    designation: designations,
    department: departments,
  };

  const handleFilterMenuClick = (type, { key }) => {
    const updatedSelection = selectedFilters[type].includes(key)
      ? selectedFilters[type].filter((item) => item !== key)
      : [...selectedFilters[type], key];
    setSelectedFilters({ ...selectedFilters, [type]: updatedSelection });
  };

  const filterMenu = (type) => (
    <Menu onClick={(item) => handleFilterMenuClick(type, item)}>
      {filters[type].map((filter) => (
        <Menu.Item key={filter.key}>
          <Checkbox checked={selectedFilters[type].includes(filter.key)}>
            {filter.value}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );
  const dropdownMenu = (
    <Menu>
      <Menu.SubMenu key="designation" title="Designation">
        {filterMenu("designation")}
      </Menu.SubMenu>
      <Menu.SubMenu key="department" title="Department">
        {filterMenu("department")}
      </Menu.SubMenu>
    </Menu>
  );
  return (
    <div>
      <div className="flex TakerTabs mt-3">
        <Radio.Group value={size} onChange={onChange}>
          <Radio.Button onClick={() => toggleFilterRadioBtn()} value="All">
            All
          </Radio.Button>
          <Radio.Button
            onClick={() =>
              toggleFilterRadioBtn({
                roles: [STAFF_ROLE.AttendanceTaker],
                projection: { needStaffRole: false },
              })
            }
            value="attendanceTaker"
          >
            Attendance Taker
          </Radio.Button>
          <Radio.Button
            onClick={() =>
              toggleFilterRadioBtn({
                roles: [STAFF_ROLE.AddStaff],
                projection: { needStaffRole: false },
              })
            }
            value="assignRights"
          >
            Staff
          </Radio.Button>
        </Radio.Group>
      </div>
      <Row className="">
        <Col lg={10}>
          <div className="flex justify-between mt-3">
            <div className="flex">
              {/* {isSearchVisible && (
                            <input
                            type="text"
                            id="filter-text-box"
                            placeholder="Search..."
                            onInput={onFilterTextBoxChanged}
                          />
                         )}
                            <SearchOutlined onClick={toggleSearchVisibility} className='assign-all-search ml-3 mr-1' /> */}
              {/* <FilterOutlined className='assign-all-search mr-1' /> */}
              <Dropdown
                overlay={dropdownMenu}
                trigger={["click"]}
                placement="bottom"
              >
                <img
                  src={Filter}
                  className="assign-all-search mr-1 cursor-pointer"
                />
              </Dropdown>
            </div>
            <div>
              <button
                onClick={() => showForm()}
                className="h-[35px] border !border-[#00305F] px-6 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
              >
                + Add more
              </button>
            </div>
          </div>
          <div
            className="ag-theme-alpine text-base border-none font-proxima"
            style={{ height: "auto", width: "100%", marginTop: "10px" }}
          >
            <AgGridReact
              ref={gridRef}
              gridOptions={gridOptions}
              columnDefs={columnDefs}
              rowData={data}
              domLayout="autoHeight"
              onGridReady={(params) => setGridApi(params.api)}
              pagination={true}
              getRowHeight={() => 60}
              paginationPageSize={20}
              paginationPageSizeSelector={false}
            />
          </div>
        </Col>
      </Row>
      <StaffDetail
        open={formVisible}
        onCancel={hideForm}
        isAttendanceHead={false}
      />
    </div>
  );
}

export default AttendanceTacker;
